/* WC — Third-party script gate (SAFE v2)
   Defers heavy/duplicated scripts (autofill, analytics, trackers) until interaction/idle.
   Built from strings → no regex literal pitfalls; ES5-compatible. */
(function () {
  var patternStrings = [
    'bootstrapAutofill','autofillFunctions','autofill',
    'Settings-.*\\.js','types-.*\\.js','isVisible-.*\\.js',
    'bugsnag','sentry',
    'googletagmanager','gtag\\/js','collect\\?','analytics\\.js',
    'hotjar','clarity','segment','fullstory','mouseflow',
    'facebook','fbq','snap','tiktok',
    'klaviyo','omnisend','mailchimp',
    'judge\\.me','yotpo','loox','stamped','okendo',
    'hextom','bold','recharge'
  ];
  var patterns = [];
  for (var i = 0; i < patternStrings.length; i++) {
    try { patterns.push(new RegExp(patternStrings[i], 'i')); } catch (e) {}
  }
  function shouldGate(src) {
    try { for (var i = 0; i < patterns.length; i++) if (patterns[i].test(src)) return true; } catch (e) {}
    return false;
  }
  var seen = (typeof Set !== 'undefined') ? new Set() : { has: function(){return false;}, add: function(){} };
  var delayed = [];

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var nodes = muts[i].addedNodes || [];
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n && n.tagName === 'SCRIPT' && n.src) {
          var src = n.src;
          if (seen.has && seen.has(src)) { if (n.parentNode) n.parentNode.removeChild(n); continue; }
          if (seen.add) seen.add(src);
          if (shouldGate(src)) {
            delayed.push(src);
            if (n.parentNode) n.parentNode.removeChild(n);
          }
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  function unique(list) {
    if (Array.from && window.Set) return Array.from(new Set(list));
    var out = []; for (var i=0;i<list.length;i++) if (out.indexOf(list[i]) === -1) out.push(list[i]); return out;
  }

  function injectDelayed() {
    if (!delayed.length) return;
    var urls = unique(delayed);
    delayed = [];
    for (var i = 0; i < urls.length; i++) {
      var s = document.createElement('script');
      s.src = urls[i];
      s.defer = true; // do not block parsing
      s.setAttribute('data-wc-delayed','1');
      document.body.appendChild(s);
    }
    try { mo.disconnect(); } catch (e) {}
  }

  window.addEventListener('pointerdown', injectDelayed, { once: true });
  window.addEventListener('keydown',   injectDelayed,   { once: true });
  window.addEventListener('load', function () {
    if (window.requestIdleCallback) {
      requestIdleCallback(injectDelayed, { timeout: 2500 });
    } else {
      setTimeout(injectDelayed, 1);
    }
  }, { once: true });
})();
